const DEFAULT_DIRECT_BASE_URL = "https://medcode-ai-service-383313534849.us-east1.run.app";

const DIRECT_BASE_URL = process.env.REACT_APP_API_URL || DEFAULT_DIRECT_BASE_URL;
const GATEWAY_BASE_URL = process.env.REACT_APP_API_GATEWAY_URL || DIRECT_BASE_URL;
const API_GATEWAY_KEY = process.env.REACT_APP_API_GATEWAY_KEY || "";
const USE_API_GATEWAY = (process.env.REACT_APP_USE_API_GATEWAY || "false").toLowerCase() === "true";
const API_GATEWAY_AUTH_MODE = (process.env.REACT_APP_API_GATEWAY_AUTH_MODE || "apikey").toLowerCase();

const EXCLUDED_PREFIXES = (process.env.REACT_APP_API_GATEWAY_EXCLUDE_PREFIXES || "")
  .split(",")
  .map((value) => value.trim())
  .filter(Boolean);

export type BuildApiUrlOptions = {
  forceDirect?: boolean;
};

const normalizePath = (path: string) => {
  if (!path) return "/";
  if (/^https?:\/\//i.test(path)) return path;
  return path.startsWith("/") ? path : `/${path}`;
};

const isExcludedPath = (path: string) => EXCLUDED_PREFIXES.some((prefix) => path.startsWith(prefix));

const shouldUseGatewayForPath = (path: string, options: BuildApiUrlOptions = {}) =>
  USE_API_GATEWAY && !options.forceDirect && !isExcludedPath(path);

export type ResolvedApiUrl = {
  url: string;
  useGateway: boolean;
};

export const resolveApiUrl = (path: string, options: BuildApiUrlOptions = {}): ResolvedApiUrl => {
  const normalized = normalizePath(path);
  if (/^https?:\/\//i.test(normalized)) {
    return {
      url: normalized,
      useGateway: false,
    };
  }

  const useGateway = shouldUseGatewayForPath(normalized, options);
  const base = useGateway ? GATEWAY_BASE_URL : DIRECT_BASE_URL;
  const url = new URL(normalized, base.endsWith("/") ? base : `${base}/`);

  if (useGateway && API_GATEWAY_AUTH_MODE !== "firebase" && API_GATEWAY_KEY) {
    url.searchParams.set("key", API_GATEWAY_KEY);
  }

  return {
    url: url.toString(),
    useGateway,
  };
};

export const buildApiUrl = (path: string, options: BuildApiUrlOptions = {}) =>
  resolveApiUrl(path, options).url;
